import studiesData from '../data/studies.json';

function unescapeEntities(str) {
  if (!str) return '';
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

export function renderStudyDetail(container, slug) {
  if (!container) return;

  const study = studiesData.find(s => s.slug === slug);

  if (!study) {
    container.innerHTML = `
      <div class="wt-container text-center" style="padding: 5rem 1rem;">
        <i class="fa-solid fa-triangle-exclamation" style="font-size:3rem; color:var(--accent-gold); margin-bottom:1rem;"></i>
        <h2>Study Not Found</h2>
        <p style="color:var(--text-secondary); margin-bottom:1.5rem;">The requested Bible study could not be located.</p>
        <a href="#studies" class="btn-primary">Back to Bible Studies</a>
      </div>
    `;
    return;
  }

  container.innerHTML = `
    <div class="study-detail-page">
      <!-- Breadcrumb Nav -->
      <nav class="wt-container study-breadcrumb" aria-label="Breadcrumbs">
        <a href="#home"><i class="fa-solid fa-house"></i> Home</a>
        <span class="bc-sep">/</span>
        <a href="#studies">Bible Studies</a>
        <span class="bc-sep">/</span>
        <span class="bc-current">${study.title}</span>
      </nav>

      <div class="wt-container study-detail-layout">
        <!-- Main Content Area -->
        <article class="study-detail-main">
          ${study.featured_image ? `
            <div class="study-detail-hero-media">
              <img src="${study.featured_image}" alt="${study.title}" class="study-detail-img" />
            </div>
          ` : ''}

          <div class="study-detail-header">
            <div class="study-tag-pills" style="margin-bottom:0.75rem;">
              ${study.categories.map(c => `<span class="study-tag-pill highlight">${c}</span>`).join('')}
              ${study.tags.map(t => `<span class="study-tag-pill">${t}</span>`).join('')}
            </div>
            <h1 class="study-detail-title">${study.title}</h1>
          </div>

          <!-- Quick Action Downloads Bar -->
          <div class="study-download-card">
            <div class="study-download-card-info">
              <h3><i class="fa-solid fa-cloud-arrow-down"></i> Study Materials & Downloads</h3>
              <p>Download free printable files or open directly in your browser:</p>
            </div>
            <div class="study-download-buttons">
              ${study.pdf_url ? `
                <a href="${study.pdf_url}" download="${study.pdf_filename || 'study.pdf'}" class="dl-action-btn pdf">
                  <i class="fa-solid fa-file-pdf"></i>
                  <span>
                    <strong>Download PDF</strong>
                    <small>Printable study guide</small>
                  </span>
                </a>
              ` : ''}

              ${study.docx_url ? `
                <a href="${study.docx_url}" download="${study.docx_filename || 'study.docx'}" class="dl-action-btn docx">
                  <i class="fa-solid fa-file-word"></i>
                  <span>
                    <strong>Download DOCX</strong>
                    <small>Editable Word document</small>
                  </span>
                </a>
              ` : ''}

              ${study.google_doc_url ? `
                <a href="${study.google_doc_url}" target="_blank" rel="noopener noreferrer" class="dl-action-btn gdoc">
                  <i class="fa-brands fa-google-drive"></i>
                  <span>
                    <strong>Open in Google Docs</strong>
                    <small>Read online live</small>
                  </span>
                </a>
              ` : ''}
            </div>
          </div>

          <!-- Description & Content -->
          <div class="study-detail-body">
            <h2>Overview & Learning Objectives</h2>
            <div class="study-prose">
              ${unescapeEntities(study.description).split('\n').map(p => p.trim() ? `<p>${p}</p>` : '').join('')}
            </div>
          </div>

          <!-- Bottom Navigation -->
          <div class="study-detail-footer-nav">
            <a href="#studies" class="btn-secondary">
              <i class="fa-solid fa-arrow-left"></i> All Bible Studies
            </a>
            <a href="#course" class="btn-primary">
              Explore Discipleship Cohorts <i class="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        </article>

        <!-- Sidebar -->
        <aside class="study-detail-sidebar">
          <div class="study-sidebar-card">
            <h3>More Bible Studies</h3>
            <div class="sidebar-studies-list">
              ${studiesData.filter(s => s.slug !== slug).slice(0, 4).map(other => `
                <a href="#study/${other.slug}" class="sidebar-study-item">
                  <img src="${other.featured_image || '/assets/martin-pechy-u-2g_UCBP4E-unsplash-1024x683.jpg'}" alt="${other.title}" />
                  <div>
                    <h4>${other.title}</h4>
                    <span>${other.categories.join(' • ')}</span>
                  </div>
                </a>
              `).join('')}
            </div>
            <a href="#studies" class="sidebar-view-all">View All ${studiesData.length} Studies &rarr;</a>
          </div>

          <div class="study-sidebar-card discipleship-callout">
            <i class="fa-solid fa-hands-holding-child"></i>
            <h3>Walk Together Discipleship</h3>
            <p>Join our 23-lesson cohort curriculum helping you fulfill your calling as a disciple maker.</p>
            <a href="#course" class="btn-primary w-full text-center">Start Discipleship 101</a>
          </div>
        </aside>
      </div>
    </div>
  `;
}
